import React from 'react';
import { Link } from 'react-router-dom';
import { professorData } from '../mock';

export const Footer = () => {
  return (
    <footer className="bg-[#0F172A] text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center space-y-4">
          <Link to="/">
            <h3 className="text-2xl font-serif font-bold text-[#B49163] hover:text-[#9a7a52] transition-colors duration-300">
              Universo do Direito
            </h3>
          </Link>
          <p className="text-gray-300">
            Gestão {professorData.name}
          </p>
          <p className="text-gray-400 text-sm">
            © 2025 Universo do Direito - Todos os direitos reservados
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;